/**
 * Shared types for discount handling across the upsell module
 */

/**
 * Discount data structure as returned from the API (EstimateProrate)
 */
export type ApiDiscount = {
  discountPercentage: number
  amount: number
  discountType: string
  lineItemId?: string
  period?: number
  periodUnit?: string
}

/**
 * Discount calculation result for a specific addon
 */
export type DiscountCalculation = {
  discountPercentage: number
  amount: number
  discountType: string
  lineItemId?: string
}

/**
 * Period unit values
 */
export type PeriodUnit = 'year' | 'month' | 'week' | 'day'
/**
 * Default discount period values
 */
export const DEFAULT_DISCOUNT_PERIOD = {
  VALUE: 1,
  UNIT: 'year',
} as const
